__turbopack_context__.v({
  "container": "eHUK2G_container",
  "isNavigating": "eHUK2G_isNavigating",
  "progress": "eHUK2G_progress",
});
